import { render, staticRenderFns } from "./badhan.vue?vue&type=template&id=23322068&scoped=true&"
import script from "./badhan.vue?vue&type=script&lang=js&"
export * from "./badhan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23322068",
  null
  
)

export default component.exports